import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import errorCode from '@/utils/errorCode'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 对应国际化资源文件后缀
axios.defaults.headers['Content-Language'] = 'zh_CN'

// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // 超时
  timeout: 10000 * 6
})
// request拦截器
service.interceptors.request.use(
  (config) => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    if (getToken() && !isToken) {
      config.headers.Authorization = `Bearer ${getToken()}` // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    const { isSaas=false,isApplet } = config.headers || {}
    if (isSaas) {
      config.url = process.env.VUE_APP_UDI_API + config.url // 让每个请求baseUrl更改 请根据实际情况自行修改
    }else if(isApplet){
      config.url = process.env.VUE_APP_APPLET_API + config.url // 让每个请求baseUrl更改 请根据实际情况自行修改
      config.headers.tenantId = store.state.user.userInfo.tenantId
    } else {
      config.url = process.env.VUE_APP_BASE_API + config.url // 让每个请求baseUrl更改 请根据实际情况自行修改
    }

    // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = `${config.url}?`
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName]
        const part = `${encodeURIComponent(propName)}=`
        if (value !== null && typeof value !== 'undefined') {
          if (typeof value === 'object') {
            for (const key of Object.keys(value)) {
              if (value[key] !== null && typeof value[key] !== 'undefined') {
                const params = `${propName}[${key}]`
                const subPart = `${encodeURIComponent(params)}=`
                url += `${subPart + encodeURIComponent(value[key])}&`
              }
            }
          } else {
            url += `${part + encodeURIComponent(value)}&`
          }
        }
      }
      url = url.slice(0, -1)
      config.params = {}
      config.url = url
    }
    return config
  },
  (error) => {
    console.log(error)
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    // 未设置状态码则默认成功状态
    const code = +res.data.code || 200
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode.default
    if (code === 401) {
      MessageBox.confirm('登录状态已过期，请重新登录', '系统提示', {
        confirmButtonText: '重新登录',
        showCancelButton: false,
        type: 'warning'
      })
        .then(() => {
          store.dispatch('LogOut').then(() => {
            location.href = process.env.VUE_APP_CONTEXT_PATH
          })
        })
        .catch(() => { })
      return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    }
    if (code === 500) {
      Message({
        message: msg,
        type: 'error'
      })
      return Promise.reject(new Error(msg))
    }
    if (code !== 200) {
      Notification.error({
        title: msg
      })
      return Promise.reject('error')
    }
    return res.data
  },
  (error) => {
    let { message } = error
    if (message == 'Network Error') {
      message = '后端接口连接异常'
    } else if (message.includes('timeout')) {
      message = '系统接口请求超时'
    } else if (message.includes('Request failed with status code')) {
      message = `系统接口${message.substr(message.length - 3)}异常`
    }
    Message({
      message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
